// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 19.714A1.286 1.286 0 0119.714 21H5.571A2.571 2.571 0 013 18.429V4.286a1.286 1.286 0 012.571 0v13.821a.321.321 0 00.322.322h13.821A1.286 1.286 0 0121 19.714z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;